import { Box } from '@radix-ui/themes';
import { CSSProperties, PropsWithChildren, RefObject } from 'react';
import { useScrollPosition } from '@common/hooks';

interface ParallaxLayerProps extends PropsWithChildren {
    speed?: number;
    scrollContainerRef: RefObject<HTMLElement | null>;
    zIndex?: number;
    className?: string;
}

export const ParallaxLayer = ({
    children,
    speed = 0.5,
    scrollContainerRef,
    zIndex = 0,
    className,
}: ParallaxLayerProps) => {
    const { scrollY } = useScrollPosition(scrollContainerRef);
    const translateY = scrollY * speed;

    const style: CSSProperties = {
        transform: `translate3d(0, ${-translateY}px, 0)`,
        willChange: 'transform',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex,
    };

    return (
        <Box style={style} className={className}>
            {children}
        </Box>
    );
};
